import { CallToAction } from 'components/CallToAction'
import React from 'react'
import { heading, section } from './classes'

const SupportStat = ({ title, description }) => {
    return (
        <li className="p-6">
            <div className="text-2xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-t from-primary to-white">
                {title}
            </div>
            <div className="text-17px mt-2 font-semibold">{description}</div>
        </li>
    )
}

export default function Support() {
    return (
        <section className={section('text-center')}>
            <div className="bg-primary w-full rounded-lg px-4 py-16 dark">
                <h2 className={heading('md', 'white')}>
                    iCloudReady's <span className="text-red">proven</span> support
                </h2>
                <h3 className={heading('sm', 'tan')}>The Fastest Path to Peak Performance</h3>
                <ul className="grid sm:grid-cols-3 text-white m-0 p-0 list-none my-8 sm:my-20 divide-gray-accent-light divide-y-1 sm:divide-y-0 sm:divide-x-1 divide-dashed">
                    <SupportStat
                        title="Remarkable service"
                        description="You matter to us. It's that simple. No matter if it's onboarding, support, or strategic advice."
                    />
                    <SupportStat
                        title="Dynamic technology"
                        description="Rely on a platform built for stability, scale, and innovation - constantly improved through automatic updates - with you and your users in mind."
                    />
                    <SupportStat
                        title="Powerful workflows"
                        description="Digitize, streamline, and automate your processes with flexible tools and advanced AI."
                    />
                </ul>
                <CallToAction type="outline" width="56" href="https://icloud-ready.com">
                    Learn More
                </CallToAction>
            </div>
        </section>
    )
}
